import Vue from 'vue'
import Router from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('../views/mine.vue')
    },
    {
      path: '/collect',
      name: 'collect',
      component: () => import('../views/collect.vue')
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('../views/history.vue')
    },
    {
      path: '/isme',
      name: 'isme',
      component: () => import('../views/isme.vue')
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: () => import('../views/disclaimer.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/search.vue')
    },
    {
      path: '/plan',
      name: 'plan',
      component: () => import('../views/plan.vue')
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('../views/video.vue')
    },
    {
      path: '/videoInfo',
      name: 'videoInfo',
      component: () => import('../views/videoInfo.vue')
    },
    {
      path: '/exhibit',
      name: 'exhibit',
      component: () => import('../views/exhibit.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('../views/exhibitinfo.vue')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('../views/map.vue')
    },
    {
      path: '/historyMap',
      name: 'historyMap',
      component: () => import('../views/historyMap.vue')
    },
    {
      path: '/historyMapVideoList',
      name: 'historyMapVideoList',
      component: () => import('../views/historyMapVideoList.vue')
    },
    {
      path: '/onsearch',
      name: 'onsearch',
      component: () => import('../views/onsearch.vue')
    },
    {
      path: '/noqx',
      name: 'noqx',
      component: () => import('../views/noqx.vue')
    }
  ]
})

export default router